import { render } from "./PostSubpage.vue?vue&type=template&id=8f56d91c&scoped=true"
import script from "./PostSubpage.vue?vue&type=script&lang=js"
export * from "./PostSubpage.vue?vue&type=script&lang=js"

import "./PostSubpage.vue?vue&type=style&index=0&id=8f56d91c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f56d91c"]])

export default __exports__